import { createContext } from "react"

const defaultState = {
  completedBooks: new Map(),
  toggleBookComplete: () => {},
}

const AppContext = createContext(defaultState)

export default AppContext
